module.exports = __webpack_public_path__ + "static/media/straws.7d3433ab.jpg";